import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';

@CopyProperties()
export class DividendModel {
  public id: any;
  public dividendAmt: number;
  public dividendDate: any;
  public paymentDate: any;
  public exDividendDate: any;
  public createAt: any;
  public productId: any;
  constructor(params?) {
    this.id = undefined;
    this.dividendAmt = 0;
    this.dividendDate = null;
    this.paymentDate = null;
    this.exDividendDate = null;
    this.createAt = null;
    this.productId = null;
  }
}
